export default __webpack_public_path__ + "static/home-banner-38e62654e416f570573e7e1364004026.jpg";